import { createContext } from 'react';
// import Plausible from 'plausible-tracker';

import { TrackingEvent } from './Tracking.events';
import { MatomoTracker as Matomo } from '@canvasflow/analytics';

export const LOCATION_CHANNEL_KEY = 'location';

export const TrackingContext = createContext<ContextProps>({
	gtag: null,
	gtm: null,
	metaPixel: null,
	tiktokPixel: null,
	segment: null,
	locationChannel: new BroadcastChannel(LOCATION_CHANNEL_KEY),
	matomo: null,
	sendEvent: () => {},
});

interface ContextProps {
	location?: Location;
	locationChannel: BroadcastChannel;
	sendEvent: (event: TrackingEvent) => void;
	gtag?: any;
	gtm?: any;
	plausible?: any;
	tiktokPixel?: any;
	metaPixel?: any;
	segment?: any;
	matomo?: Matomo | null;
}
